<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">主播实时监控报表</h1>
    <el-row :gutter="20" class="user-options">
      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        style="width: 100%"
        v-loading="login1"
        stripe
        border
      >
        <el-table-column
          prop="trialHostCount"
          label="匹配筛选主播池主播数"
          width="200"
        >
        </el-table-column>

        <el-table-column
          prop="onlineTrialHostCount"
          label="匹配筛选主播池在线主播数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="qualityHostCount"
          label="优质主播池主播数"
          width="180"
        >
        </el-table-column>

        <el-table-column
          prop="onlineQualityHostCount"
          label="优质主播池在线主播数"
          width="180"
        >
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
        :page-size="30"
      ></el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'

export default {
  data () {
    return {
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      // 通话日期
      platformData: [datainfor(1), datainfor(1)],
      retainedOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],

      country: 'total',
      countryList: [],
      hostRid: '',
      language: 'all',
      languageList: []
    }
  },
  async created () {
    await this._getLanguage()
    this.getDayChatDetai()
    this._getCountry()
  },
  methods: {
    async _getCountry () {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async _getLanguage () {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
        this.language = res[0].langCode
      }
    },
    // 查询列表
    async getDayChatDetai () {
      this.login1 = true

      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.real_time_data,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      let list = []
      list[0] =res.data
      this.dayChatDetailData = list
      this.total = res.data.total
    },
    // 下载
    async dwnDayChatDetai () {
      this.login2 = true
      const res = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.pay_goods_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          country: this.country,
          hostRid: this.hostRid,
          language: this.language
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '主播流量总览数据' + this.platformData[1])
    },
    // 分页
    handleCurrentChange () {
      this.getDayChatDetai()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  .el-col {
    display: flex;
    align-items: center;

    >div {
      margin-right: 5px;
    }
  }

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
</style>
